var React = require('react');

function ChessRookAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 473.89V496a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-22.11a16 16 0 0 1 8.85-14.31L32 448v-16a16 16 0 0 1 16-16h224a16 16 0 0 1 16 16v16l23.16 11.58a16 16 0 0 1 8.84 14.31z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M71.81 210.32L57.33 384h205.34l-14.48-173.7 30.62-31.11a32 32 0 0 0 9.19-22.45V72a8 8 0 0 0-8-8h-35.18a8 8 0 0 0-8 8v40h-32.94V72a8 8 0 0 0-8-8h-71.75a8 8 0 0 0-8 8v40H83.19V72a8 8 0 0 0-8-8H40a8 8 0 0 0-8 8v84.82a32 32 0 0 0 9.21 22.47zm64.6 21.27a23.59 23.59 0 0 1 47.18 0v47.18h-47.18z","className":"fa-primary","key":2})]);
}

ChessRookAlt.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = ChessRookAlt;

ChessRookAlt.default = ChessRookAlt;
